export default __webpack_public_path__ + "static/media/fiolet_hertz.c7ec6c64.svg";